import { render, staticRenderFns } from "./ScreenshotSelection.vue?vue&type=template&id=206954d1&scoped=true"
import script from "./ScreenshotSelection.vue?vue&type=script&lang=js"
export * from "./ScreenshotSelection.vue?vue&type=script&lang=js"
import style0 from "./ScreenshotSelection.vue?vue&type=style&index=0&id=206954d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206954d1",
  null
  
)

export default component.exports